import React, { PropTypes } from 'react';
import { connect } from 'react-redux'
import NotificationTable from '../../components/notification/NotificationTable';
import { fetchMessagesIfNeeded } from '../../actions/NotificationAction';

class NotificationList extends React.Component {

  componentDidMount() {
    this.props.dispatch(fetchMessagesIfNeeded());
  }

  render(){

    if (this.props.isFetching && this.props.notifications.length == 0) {
      return <p>Loading...</p>
    }

    return <NotificationTable notifications={this.props.notifications} />;
  }
}

NotificationList.propType = {
  notifications: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    notifications: state.notification.notifications,
    isFetching: state.notification.isFetching
  }
}

export default connect(mapStateToProps)(NotificationList);



// WEBPACK FOOTER //
// ./src/pages/notification/NotificationList.js